import "../node_modules/css-preflight/styles/preflight.css";
import "../node_modules/css-preflight/styles/smooth-scroll.css";
import "../node_modules/css-preflight/styles/text-wrap-balance.css";

import "../scss/screen.scss";

import $ from "jquery";
import loadjs from "loadjs";
import {UAParser} from "ua-parser-js";
import TypeIt from "typeit";
import yall from "yall-js";
import {initializeLegacySite, initializeVideos} from "./src/script.js";

Object.assign(window, {
    $,
    jQuery: $,
    loadjs,
    UAParser,
    TypeIt,
    yall,
});

// jPlayer 2.x still calls the jQuery helper removed in jQuery 4.
if (typeof $.isFunction !== "function") {
    $.isFunction = (value) => typeof value === "function";
}

const loadVideoPlayer = (initializeVideos) => {
    const load = () => import("jplayer").then(() => initializeVideos());

    // jPlayer is only needed by the legacy self-hosted video element. Deferring
    // it prevents a page without a video from putting it on the LCP request path.
    if (document.readyState === "complete") {
        load();
        return;
    }

    window.addEventListener("load", load, {once: true});
};

initializeLegacySite();

if (document.querySelector(".el-video")) {
    loadVideoPlayer(initializeVideos);
}
